/* eslint-disable no-console */
import axios from "axios";

const API_URL = "https://restcountries.com/v3.1/all?fields=name,cca2,idd";

export const getCountries = async () => {
  try {
    const response = await axios.get(API_URL);
    const countries = response.data.map((country) => {
      const dialingCode = country.idd.root
        ? `${country.idd.root}${country.idd.suffixes ? country.idd.suffixes[0] : ""}`
        : "";
      return {
        name: country.name.common,
        code: country.cca2,
        dialingCode,
      };
    });
    return countries;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};
